module.exports = __webpack_public_path__ + "1607c10031a78777876f5a22dfc20055.svg";